import { Card } from './Card.jsx';
import { ActionButton } from './ActionButton.jsx';

function ReasonList({ title, items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="reason-block">
      <strong>{title}</strong>
      <ul>
        {items.slice(0, 3).map((item) => <li key={item}>{item}</li>)}
      </ul>
    </div>
  );
}

export function PlannerCard({ item }) {
  const score = Number(item.score || 0);
  return (
    <Card tone={item.tone}>
      <div className="card-head">
        <div>
          <span className="eyebrow">{item.priority || item.eyebrow} · {item.eyebrow}</span>
          <h3>{item.title}</h3>
        </div>
        <div className="score-badge">
          <span>{score}</span>
          <small>AI score</small>
        </div>
      </div>
      <p>{item.text}</p>
      {item.nextBestAction && <div className="next-action">Next best action: <strong>{item.nextBestAction}</strong></div>}
      <div className="meta-row">
        {(item.meta || []).map((m) => <span key={m}>{m}</span>)}
      </div>
      <div className="explain-grid">
        <ReasonList title="Почему важно" items={item.why} />
        <ReasonList title="Риски" items={item.risks} />
      </div>
      <div className="confidence-row">
        <span>Confidence {item.confidence || 70}%</span>
        <span>Signals {Object.keys(item.signals || {}).length}</span>
      </div>
      <div className="action-row">
        {(item.actions || []).map((action) => (
          <ActionButton key={action.action} {...action} payload={{ itemId: item.id, score: item.score, priority: item.priority }} />
        ))}
      </div>
    </Card>
  );
}
